// @ts-nocheck
/**
 * Shared phone field helpers for contact, quote, and tax-exempt forms.
 */
(function () {
  function getPhoneLib() {
    return window.libphonenumber;
  }

  function waitForLib(timeoutMs = 8000) {
    return new Promise((resolve) => {
      const start = Date.now();

      const tick = () => {
        const lib = getPhoneLib();
        if (lib && typeof lib.parsePhoneNumberFromString === 'function') {
          resolve(lib);
          return;
        }
        if (Date.now() - start >= timeoutMs) {
          resolve(null);
          return;
        }
        requestAnimationFrame(tick);
      };

      tick();
    });
  }

  function normalizeDigits(rawNumber) {
    return rawNumber.replace(/\D+/g, '');
  }

  function isValidUsPhone(digits) {
    return digits.length === 10 || (digits.length === 11 && digits.startsWith('1'));
  }

  function toUsE164(digits) {
    return digits.length === 10 ? `+1${digits}` : `+${digits}`;
  }

  function phoneNumberIsValid(parsed) {
    if (!parsed) return false;
    if (typeof parsed.isValid === 'function') return parsed.isValid();
    return Boolean(parsed.isValid);
  }

  function dialCodeFor(country, lib) {
    const phoneLib = lib || getPhoneLib();
    if (phoneLib && typeof phoneLib.getCountryCallingCode === 'function' && country) {
      try {
        return String(phoneLib.getCountryCallingCode(country));
      } catch (error) {
        // Fall through to the label or US default.
      }
    }

    return country === 'US' ? '1' : '';
  }

  function selectedDialCode(selectEl) {
    const option = selectEl?.selectedOptions?.[0];
    if (option?.dataset.dialCode) return option.dataset.dialCode;

    const fromLabel = option?.textContent?.match(/\+(\d+)/);
    if (fromLabel) return fromLabel[1];

    const country = selectEl?.value || 'US';
    return dialCodeFor(country) || '1';
  }

  async function populateCountryOptions(selectEl) {
    if (!selectEl) return;

    const lib = await waitForLib();
    const currentCountry = selectEl.value || 'US';

    if (lib && typeof lib.getCountries === 'function' && typeof lib.getCountryCallingCode === 'function') {
      const countries = lib.getCountries();
      const displayNames = typeof Intl !== 'undefined' && typeof Intl.DisplayNames === 'function'
        ? new Intl.DisplayNames(['en'], { type: 'region' })
        : null;

      const countryList = countries.slice().sort((a, b) => {
        const aName = displayNames?.of(a) || a;
        const bName = displayNames?.of(b) || b;
        return aName.localeCompare(bName);
      });

      selectEl.innerHTML = '';
      countryList.forEach((countryCode) => {
        const dialCode = dialCodeFor(countryCode, lib);
        const option = document.createElement('option');
        option.value = countryCode;
        option.dataset.dialCode = dialCode;
        const countryName = displayNames?.of(countryCode) || countryCode;
        option.textContent = `+${dialCode} ${countryName}`;
        selectEl.append(option);
      });

      selectEl.value = countryList.includes(currentCountry) ? currentCountry : 'US';
    }
  }

  function syncValue({ phoneInput, phoneCountry, phoneE164Input, markInvalid, errorClass }) {
    if (!phoneInput || !phoneCountry || !phoneE164Input) {
      return { valid: true, e164: '' };
    }

    const rawNumber = phoneInput.value.trim();
    const selectedCountry = phoneCountry.value || 'US';
    const dialCode = selectedDialCode(phoneCountry);
    const lib = getPhoneLib();

    const setInvalid = () => {
      if (markInvalid) phoneInput.classList.add(errorClass);
    };
    const clearInvalid = () => phoneInput.classList.remove(errorClass);

    if (!rawNumber) {
      phoneE164Input.value = '';
      setInvalid();
      return { valid: false, e164: '' };
    }

    if (lib && typeof lib.parsePhoneNumberFromString === 'function') {
      const parsed = lib.parsePhoneNumberFromString(rawNumber, selectedCountry);
      if (phoneNumberIsValid(parsed)) {
        phoneE164Input.value = parsed.number;
        clearInvalid();
        return { valid: true, e164: parsed.number };
      }
    }

    let digits = normalizeDigits(rawNumber);
    if (rawNumber.startsWith('+') && dialCode && digits.startsWith(dialCode)) {
      digits = digits.slice(dialCode.length);
    }

    if (dialCode && digits.length >= 6 && digits.length <= 15) {
      const e164 = `+${dialCode}${digits}`;
      phoneE164Input.value = e164;
      clearInvalid();
      return { valid: true, e164 };
    }

    if (isValidUsPhone(digits)) {
      const e164 = toUsE164(digits);
      phoneE164Input.value = e164;
      clearInvalid();
      return { valid: true, e164 };
    }

    phoneE164Input.value = '';
    setInvalid();
    return { valid: false, e164: '' };
  }

  window.PSPhoneField = {
    waitForLib,
    populateCountryOptions,
    syncValue
  };
})();
